// 热门栏目
import * as React from 'react'
import Link from 'next/link'

import { sendTeaCommEvent } from 'lib/tea-analyze'

import Image from 'Components/image'

export interface IPopularColumn {
  count: number
  column_id: number
  name: string
  logo: string
  cover: string
  user_id: number
  media_id: number
  author_name: string
  author_avatar: string
}
interface IPopularColumnsProps {
  columns: IPopularColumn[]
}
export default function PopularColumns({ columns }: IPopularColumnsProps) {
  return (
    <section className="card">
      <div className="group-wrap">
        <h4>热门节目</h4>
        <Link href="/video/groups" key={'video-group'}>
          <a
            target="_blank"
            className="more"
            onClick={() => {
              sendTeaCommEvent('click_hot_column_more')
            }}
          >
            查看更多节目
            <i className="icon-arrow-ic-r" />
          </a>
        </Link>
      </div>
      <div className="clearfix">
        {columns.map((column, index) => {
          return (
            <Link
              key={column.column_id}
              href={`/video/group?groupId=${column.column_id}`}
              as={`/video/groups/${column.column_id}`}
            >
              <a
                target="_blank"
                className="fl column"
                onClick={() => {
                  sendTeaCommEvent('click_hot_column', {
                    rank: index,
                    column_id: column.column_id,
                    column_name: column.name,
                  })
                }}
              >
                <Image transition={false} src={column.cover} optImage={false} />
                <div className="title">
                  <span className="name">{column.name}</span>
                  <span className="count">共{column.count}期</span>
                </div>
              </a>
            </Link>
          )
        })}
      </div>
      <style jsx>
        {`
          .card {
            padding: 0 0 40px;
          }
          .group-wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          h4 {
            padding: 32px 0 15px;
            line-height: 33px;
            font-size: 24px;
          }
          .column {
            width: 290px;
            height: 165px;
            margin-right: 10px;
          }
          .column:last-child {
            margin-right: 0;
          }
          .title {
            margin-top: 12px;
            line-height: 22px;
          }
          .name {
            font-size: 16px;
            font-weight: 500;
          }
          .count {
            margin-left: 12px;
            color: #999;
            font-size: 14px;
          }
          .more {
            line-height: 22px;
            font-size: 16px;
            font-weight: normal;
            text-align: right;
          }
          .more:hover {
            color: #406599;
          }
          .icon-arrow-ic-r {
            color: #000;
            margin-top: 3px;
            margin-left: 4px;
            vertical-align: text-top;
          }
        `}
      </style>
    </section>
  )
}
